<template>
  <div class="AContainer">
    <a-table
      :columns="columns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :loading="loading"
      :data-source="TableData"
      rowKey="id"
      :scroll="{ x: '100%', y: 'calc(100vh - 290px)' }"
    >
      <template #consultType="{ text: consultType }">
        <span>
          {{ Config.consultTypeEnum[consultType] || '--' }}
        </span>
      </template>
      <template #patientName="{ record }">
        {{ record.patientProfileCommonVO?.patientProfileName || '--' }}
      </template>

      <template #consultStatus="{ text: consultStatus }">
        <span>
          {{
            ['待问诊', '进行中', '问诊结束', '已取消', '已取消', '待接诊'][consultStatus] || '--'
          }}
        </span>
      </template>
      <template #payStatus="{ text: payStatus }">
        <span>
          {{ ['无', '待支付', '已支付', '支付失败', '支付中', '订单已关闭', '退款'][payStatus] }}
        </span>
      </template>
      <template #evaluateStatus="{ text: evaluateStatus }">
        {{ ['待评价', '已评价'][evaluateStatus] || '--' }}
      </template>
      <template #score="{ record }">
        <template v-if="handleEvaluate(record) || record?.isCallRecord === 1">
          <a-button type="link" class="link" @click="goRate(record)" v-if="handleEvaluate(record)">
            {{ handleEvaluate(record) }}
          </a-button>
          <a-button
            type="link"
            class="link"
            v-if="record?.isCallRecord === 1"
            @click="toConsultList(record)"
          >
            咨询记录
          </a-button>
        </template>
        <a-button v-else type="link" class="link">--</a-button>
      </template>
    </a-table>
    <a-row type="flex" justify="start" style="margin-top: 20px">
      <a-col>
        <a-pagination
          v-if="Total"
          show-size-changer
          show-quick-jumper
          v-model:current="current"
          v-model:pageSize="pageSize"
          :total="Total"
          @change="listquery"
          @showSizeChange="listquery"
          :show-total="total => `共${Total}条`"
        />
      </a-col>
    </a-row>
    <ConRate ref="RateVisible" v-model:isNeedRate="isNeedRate" @refresh="listquery" v-if="!mode" />
    <ConsultList ref="consultListRef"></ConsultList>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, defineProps } from 'vue'
import { useStore } from 'vuex'
import { consultColumns } from './config'
import { getConsultList } from '@/api/workPlace/consult'
import ConRate from '@/components/com-rate'
import ConsultList from './ConsultList/index.vue'
import Config from '@/config/index'

const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  }
})
const consultListRef = ref(null)
const columns = computed(() => {
  if (props.mode) {
    const arr = JSON.parse(JSON.stringify(consultColumns))
    arr.pop()
    return arr
  } else {
    return consultColumns
  }
})
onMounted(() => {
  listquery()
})

const store = useStore()
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)

const Total = ref(0)
const current = ref(1)
const pageSize = ref(10)
const TableData = ref([])
const loading = ref(false)

const listquery = async () => {
  const ucUserId = props?.ucUserId || curOrder?.value?.patientInfo?.ucUserId
  loading.value = true
  const query = reactive({
    size: pageSize.value,
    current: current.value,
    ucPatientId: ucUserId
  })
  const { list, totalCount } = await getConsultList(query)
  Total.value = totalCount
  TableData.value = list
  loading.value = false
}

const isNeedRate = ref(false)
const RateVisible = ref(null)
const toConsultList = row => {
  // 需要根据后端判断显示问诊记录弹窗 需要对接
  consultListRef.value.initData(row)
}
const goRate = row => {
  if (!row.evaluationId) return false
  RateVisible.value.rate.visible = true
  RateVisible.value.rate.evaluationId = row.evaluationId
  RateVisible.value.EvaluationMethod()
}
const handleEvaluate = row => {
  const { evaluateStatus, evaluationId } = row

  if (!evaluationId) {
    return
  } else {
    if (evaluateStatus === 1) {
      return '查看评价'
    } else {
      return '去评价'
    }
  }
}
</script>

<style lang="scss" scoped>
.AContainer {
  padding: 10px 20px 0;
  .link {
    font-weight: 400;
    font-size: 14px;
    color: #1890ff;
    cursor: pointer;
  }
}
</style>
